import React, { useContext } from 'react';
import { Box, Button, Card } from 'vindi-ds-components';
import { ProductContext } from '../contexts/product_context';

function Footer({ title, subtitle }) {
  const { setOpenDiscardModal } = useContext(ProductContext);

  const openModal = () => {
    setOpenDiscardModal(true);
  };

  return (
    <Card
      width='100%'
      height='4.375em'
      css={{
        display: 'flex', justifyContent: 'flex-end', alignItems: 'right', paddingRight: '1em',
      }}
    >
      <Box margin='0.5em'>
        <Button onClick={openModal} size='large' variant='secondary'>{subtitle}</Button>
      </Box>
      <Box data-testid='boxSubmit' margin='0.5em'>
        <Button type='submit'>{title}</Button>
      </Box>
    </Card>
  );
}

export default Footer;
